import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerQnaList = () => {
  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [qnaList, setQnaList] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get('/api/seller/qna/list-data', {
        withCredentials: true,
      });

      if (res.data && res.data.ok) {
        setShopName(res.data.shop_name || '');
        setQnaList(Array.isArray(res.data.qna_list) ? res.data.qna_list : []);
      } else {
        alert(res.data?.error || 'Q&A 목록을 불러오지 못했습니다.');
      }
    } catch (err) {
      const redirect = err?.response?.data?.redirect;
      const error = err?.response?.data?.error;
      if (redirect) {
        window.location.href = redirect;
        return;
      }
      alert(error || 'Q&A 목록을 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loading}>로딩중...</div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <h2 style={styles.title}>Q&A 목록 ({shopName})</h2>

      <div style={styles.tableWrap}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>상품명</th>
              <th style={styles.th}>작성자</th>
              <th style={styles.th}>내용</th>
              <th style={styles.th}>비밀글</th>
              <th style={styles.th}>답변상태</th>
              <th style={styles.th}>작성일</th>
              <th style={styles.th}>답변일</th>
              <th style={styles.th}>관리</th>
            </tr>
          </thead>
          <tbody>
            {qnaList.map((row) => (
              <tr key={row.id}>
                <td style={styles.td}>{row.id}</td>
                <td style={styles.td}>{row.product_name || ''}</td>
                <td style={styles.td}>{row.nickname || ''}</td>
                <td
                  style={styles.contentTd}
                  dangerouslySetInnerHTML={{
                    __html: row.is_secret
                      ? '🔒 비밀글'
                      : String(row.question || '').replace(/\n/g, '<br>')
                  }}
                />
                <td style={styles.td}>{row.is_secret ? '🔒' : '공개'}</td>
                <td style={styles.td}>
                  {row.status === 'waiting' ? (
                    <span style={styles.badgeWarning}>대기</span>
                  ) : (
                    <span style={styles.badgeSuccess}>답변 완료</span>
                  )}
                </td>
                <td style={styles.td}>{row.created_at || ''}</td>
                <td style={styles.td}>{row.answered_at || '-'}</td>
                <td style={styles.td}>
                  <a href={`/seller/qna/edit?id=${encodeURIComponent(row.id)}`} style={styles.primaryBtn}>
                    답변
                  </a>
                  <a href={`/seller/qna/view?id=${row.id}`} style={styles.infoBtn}>
                    보기
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loading: { padding: '40px 0' },
  title: {
    marginTop: '20px',
    marginBottom: '24px',
    fontWeight: 'bold',
    borderBottom: '2px solid #dee2e6',
    paddingBottom: '10px',
  },
  tableWrap: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    border: '1px solid #dee2e6',
    padding: '12px',
    background: '#f8f9fa',
    fontWeight: 600,
    verticalAlign: 'middle',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  td: {
    border: '1px solid #dee2e6',
    padding: '12px',
    verticalAlign: 'middle',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  contentTd: {
    border: '1px solid #dee2e6',
    padding: '12px',
    verticalAlign: 'middle',
    textAlign: 'left',
    minWidth: '220px',
  },
  badgeWarning: {
    display: 'inline-block',
    background: '#ffc107',
    color: '#212529',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgeSuccess: {
    display: 'inline-block',
    background: '#198754',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  primaryBtn: {
    display: 'inline-block',
    marginRight: '6px',
    textDecoration: 'none',
    padding: '6px 10px',
    borderRadius: '6px',
    background: '#0d6efd',
    color: '#fff',
    fontSize: '12px',
  },
  infoBtn: {
    display: 'inline-block',
    textDecoration: 'none',
    padding: '6px 10px',
    borderRadius: '6px',
    background: '#0dcaf0',
    color: '#000',
    fontSize: '12px',
  },
};

export default SellerQnaList;